import { inject, reactive } from "vue";

export default function semanticVersion() {
  const moment = inject("$moment");

  // Format any date in Philippine Time
  const versionHistory = reactive([
    {
      version: "1.0.0",
      description: "Initial Released",
      releasedDate: moment("2026-03-03").format("LLL"),
    },
  ]);

  return {
    versionHistory,
  };
}
